export const SKEW_FACTOR_NUMBER = 0.25;
export const BINARY_NUMBER_3 = 0x3;
export const BINARY_NUMBER_8 = 0x8;
export const NUMBER_MINUS_2 = -2;
export const NUMBER_DIGITS_8 = 0.8;
export const NUMBER_0 = 0;
export const NUMBER_1 = 1;
export const NUMBER_2 = 2;
export const NUMBER_3 = 3;
export const NUMBER_4 = 4;
export const NUMBER_5 = 5;
export const NUMBER_6 = 6;
export const NUMBER_7 = 7;
export const NUMBER_8 = 8;
export const NUMBER_9 = 9;
export const NUMBER_10 = 10;
export const NUMBER_12 = 12;
export const NUMBER_15 = 15;
export const NUMBER_16 = 16;
export const NUMBER_20 = 20;
export const NUMBER_21 = 21;
export const NUMBER_22 = 22;
export const NUMBER_24 = 24;
export const NUMBER_25 = 25;
export const NUMBER_30 = 30;
export const NUMBER_32 = 32;
export const NUMBER_40 = 40;
export const NUMBER_50 = 50;
export const NUMBER_60 = 60;
export const NUMBER_80 = 80;
export const NUMBER_90 = 90;
export const NUMBER_95 = 95;
export const NUMBER_100 = 100;
export const NUMBER_101 = 101;
export const NUMBER_120 = 120;
export const NUMBER_140 = 140;
export const NUMBER_144 = 144;
export const NUMBER_148 = 148;
export const NUMBER_150 = 150;
export const NUMBER_180 = 180;
export const NUMBER_200 = 200;
export const NUMBER_201 = 201;
export const NUMBER_202 = 202;
export const NUMBER_230 = 230;
export const NUMBER_260 = 260;
export const NUMBER_250 = 250;
export const NUMBER_300 = 300;
export const NUMBER_301 = 301;
export const NUMBER_302 = 302;
export const NUMBER_370 = 370;
export const NUMBER_400 = 400;
export const NUMBER_401 = 401;
export const NUMBER_403 = 403;
export const NUMBER_404 = 404;
export const NUMBER_412 = 412;
export const NUMBER_424 = 424;
export const NUMBER_443 = 443;
export const NUMBER_500 = 500;
export const NUMBER_501 = 501;
export const NUMBER_503 = 503;
export const NUMBER_600 = 600;
export const NUMBER_768 = 768;
export const NUMBER_800 = 800;
export const NUMBER_968 = 968;
export const NUMBER_992 = 992;
export const NUMBER_1000 = 1000;
export const NUMBER_1080 = 1080;
export const NUMBER_1200 = 1200;
export const NUMBER_1440 = 1440;
export const NUMBER_1500 = 1500;
export const NUMBER_1920 = 1920;
export const NUMBER_2000 = 2000;
export const NUMBER_3000 = 3000;
export const NUMBER_3600 = 3600;
export const NUMBER_4000 = 4000;
export const NUMBER_7000 = 7000;
export const NUMBER_10000 = 10000;
export const NUMBER_30000 = 30000;
export const NUMBER_60000 = 60000;
export const OFFER_BUSINESS_MODEL_B2B_ONLY = 2;
